import { VOUCHER_TYPE_OPTIONS } from "@/constants/voucherType";
import { SelectInput, SelectInputProps } from "react-admin";

const VoucherTypeSelect = (props: Omit<SelectInputProps, "choices">) => {
  const choices = VOUCHER_TYPE_OPTIONS.map((option) => ({
    id: option.value,
    name: option.label,
  }));

  return <SelectInput {...props} choices={choices} />;
};

export default VoucherTypeSelect;
